import React from "react";
import ProfileMenu from "./ProfileMenu";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { user } = useAuth();
  const schoolName = user?.school_name;

  return (
    <header className="ae-header">
      <div style={{ paddingLeft: 8 }}>
        {schoolName && (
          <div className="ae-school-badge" title={`School ID: ${user.school_id}`}>
            <span style={{ fontSize: 15 }}>🏫</span>
            <span>{schoolName}</span>
          </div>
        )}
      </div>
      <ProfileMenu />
    </header>
  );
};

export default Header;
